import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  makeStyles,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Chip,
  Modal,
  Fade,
  Backdrop,
} from "@material-ui/core";
import { blue, green, red, yellow } from "@material-ui/core/colors";
import MaterialTable from "material-table";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
} from "src/redux/actions/reference.action";
import { sumTotal } from "src/utils/Number";
import PurchaseJobFormComponent from "src/components/forms/PurchaseJobFormComponent/PurchaseJobFormComponent";
import {
  deleteFiles,
  getAllFiles,
  getPurchaseDetails,
  getPurchaseExpense,
  getPurchaseExpenseJob,
  getPurchaseRequesitionJobById,
  getPurchaseRequestById,
  updatePurchaseRequest,
  verifyPr,
} from "src/redux/actions/purchaseRequest.action";
import Swal from "sweetalert2";
import _ from "lodash";
import AssignFormModal from "src/components/modals/AssignFormModal/AssignFormModal";
import { httpClient } from "src/utils/HttpClient";
import { hasRole, isAllowed, hasRoleDOA } from "src/utils/Auth";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import AddIcon from "@material-ui/icons/Add";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";
import Page from "src/components/Page";
import PostAddIcon from "@material-ui/icons/PostAdd";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import PauseIcon from "@material-ui/icons/Pause";
import ForwardIcon from "@material-ui/icons/Forward";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import currencyJS from "currency.js";
import FilesUploadComponent from "src/components/FilesUploadComponent";
import Moment from "moment";
import Axios from "axios";
import { imageUrl } from "src/Constants";
import download from "js-file-download";
import moment from "moment";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
  buttonAddExpense: {
    backgroundColor: yellow[500],
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function PurchaseJobEditComponent() {
  const classes = useStyles();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [openModalAssign, setOpenModalAssign] = useState(false);
  const [openAttModal, setOpenAttModal] = useState(false);

  const [valueTab, setValueTab] = React.useState(0);

  const { authorizePR } = useSelector((state) => state.authorizationReducer);

  const { currencies } = useSelector((state) => state.referenceReducer);

  const location = useLocation();

  const {
    result: { fullname, currencyid, perid, email },
  } = useSelector((state) => state.loginReducer);

  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );

  useEffect(() => {
    if (params.id) {
      dispatch(getPurchaseRequestById(params.id));
      dispatch(getPurchaseDetails(params.id));
      dispatch(getPurchaseRequesitionJobById(params.id));
      dispatch(fetchCurrencies(currencyid));
      dispatch(getPurchaseExpenseJob(params.id));
      dispatch(getPurchaseExpense(params.id));
      dispatch(findAllDepartment());
      dispatch(findAllBrand());
      dispatch(getAllFiles(params.id));
    }

    return () => {};
  }, [params.id, currencyid]);

  const {
    purchaseRequestJob,
    purchaseRequest,
    purchaseRequesteExpense,
    purchaseRequesteExpenseJob,
    purchaseRequestDetails,
    attachFiles,
  } = useSelector((state) => state.purchaseRequestReducer);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const renderLookupBrand = () => {
    if (allBrands.data) {
      let obj = allBrands.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupDepartment = () => {
    if (allDepartments.data) {
      let obj = allDepartments.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupCurrencise = () => {
    if (currencies.data) {
      let obj = currencies.data.reduce(function (acc, cur, i) {
        acc[cur.CURRENCY_ID] = cur.CURRENCY_EXC_CODE;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const compareAmount = (source, origin) => {
    return new Promise((resolve, reject) => {
      source.forEach((i, key) => {
        var original = Math.round(parseFloat(origin[key].AMOUNT) * 100000);
        var amount = Math.round(parseFloat(i.AMOUNT) * 100000);
        if (original < amount) {
          resolve(i.BUDGET_CODE);
        }
      });
      resolve(null);
    });
  };

  const ctrlAttachfile = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS === 70) {
        return true;
      }
    }

    return false;
  };

  return (
    <Page
      className={classes.root}
      title={`Purchase Requesition Job Edit (
                ${purchaseRequest.data && purchaseRequest.data.PR_NO})`}
    >
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              history.replace("/purchase-requisition-job");
            }}
          >
            Purchase Requisition List Job
          </Link>
          <Link color="textPrimary" aria-current="page">
            Purchase Requesition Job Edit (
            {purchaseRequest.data && purchaseRequest.data.PR_NO})
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition adjust on the system."
            title="Purchase Requesition Job Edit"
          />
          <Divider />
          <CardContent>
            <Box display="flex" flex={1} flexDirection="column">
              <Box>
                <PurchaseJobFormComponent
                  formValues={purchaseRequest.data}
                  handleSubmit={(value) => {}}
                />
              </Box>
              <Box display="flex" flexDirection="row">
                <Box m={1}>
                  {purchaseRequest.data &&
                    isAllowed(authorizePR.data, ["can_adj_add_item"]) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          history.push(
                            `/purchase-add-job-item/${params.id}/${purchaseRequest.data.PR_YEAR}/${purchaseRequest.data.PR_COUNTRYID}/${purchaseRequest.data.PR_COMPIDX}/${purchaseRequest.data.CREATED_SECID}`
                          );
                        }}
                        disabled={Boolean(
                          purchaseRequest.data.PR_STATUS === 60 ||
                            purchaseRequest.data.PR_STATUS === 80 ||
                            purchaseRequest.data.PR_STATUS === 100
                        )}
                      >
                        <AddIcon />
                        Add Item
                      </Button>
                    )}
                  {purchaseRequest.data &&
                    isAllowed(authorizePR.data, ["can_adj_expense"]) && (
                      <Button
                        variant="contained"
                        onClick={() => {
                          history.push(
                            `/purchase-expense-edit-job/${params.id}`
                          );
                        }}
                        disabled={Boolean(
                          purchaseRequest.data.PR_STATUS === 60 ||
                            purchaseRequest.data.PR_STATUS === 80 ||
                            purchaseRequest.data.PR_STATUS === 100
                        )}
                      >
                        <LocalAtmIcon />
                        Adjust Expense
                      </Button>
                    )}
                </Box>
                <Box
                  m={1}
                  display="flex"
                  flexDirection="row"
                  border={1}
                  flex={1}
                >
                  <Box>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => {
                        setOpenAttModal(true);
                      }}
                    >
                      ATTACH FILE
                    </Button>
                  </Box>
                  <Box p={1} display="flex" flexDirection="column">
                    {attachFiles.data &&
                      attachFiles.data.map((i) => (
                        <Chip
                          label={i.ATT_FILENAME}
                          onDelete={() => {
                            dispatch(deleteFiles(i.ATTIDX, params.id));
                          }}
                          className={classes.chip}
                        />
                      ))}
                  </Box>
                </Box>
              </Box>
              <Box flexGrow={1}>
                <AppBar position="static">
                  <Tabs
                    value={valueTab}
                    onChange={handleChangeTab}
                    aria-label="simple tabs example"
                  >
                    <Tab label="Purchase Requisition (Job)" {...a11yProps(0)} />
                    <Tab
                      label="Purchase Requisition (Master)"
                      {...a11yProps(1)}
                    />
                  </Tabs>
                </AppBar>
                <TabPanel value={valueTab} index={0}>
                  <MaterialTable
                    title
                    columns={[
                      {
                        title: "No",
                        render: (rowData) => rowData.tableData.id + 1,
                      },
                      {
                        title: "PO No.",
                        field: "PO_NO",
                      },
                      {
                        title: "Budget Code",
                        field: "BUDGET_CODE",
                      },
                      {
                        title: "Project Code",
                        field: "BUDGETP_CODE",
                      },
                      {
                        title: "Item Name",
                        field: "ITEMS_DETAIL",
                      },
                      {
                        title: "Brand",
                        field: "PR_BRANDID",
                        lookup: renderLookupBrand(),
                      },
                      {
                        title: "Department",
                        field: "PR_DEPARTID",
                        lookup: renderLookupDepartment(),
                      },
                      {
                        title: "Price",
                        field: "PRICE",
                        render: (rowData) =>
                          currencyJS(rowData.PRICE, {
                            precision: 4,
                            symbol: "",
                          }).format(),
                      },
                      {
                        title: "Currency",
                        field: "CURR_ID",
                        lookup: renderLookupCurrencise(),
                      },
                      {
                        title: "QTY",
                        field: "QTY",
                      },
                      {
                        title: "Unit",
                        field: "PR_UNIT",
                      },
                      {
                        title: "Supplier",
                        field: "SUPNAME",
                        width: "40ch",
                      },
                      {
                        title: "Original Amount",
                        field: "PRICE",
                        render: (rowData) => {
                          let result = _.find(currencies.data, {
                            CURRENCY_ID: currencyid,
                          });
                          let originalCurrency = 0;
                          if (result) {
                            originalCurrency = result.CURRENCY_EXC_ID;
                          }
                          return currencyJS(
                            originalCurrency * rowData.PRICE * rowData.QTY,
                            {
                              symbol: "",
                              precision: 4,
                            }
                          ).format();
                        },
                      },
                      {
                        title: "Budget Amount",
                        field: "AMOUNT",
                        render: (rowData) =>
                          currencyJS(rowData.AMOUNT, {
                            precision: 4,
                            symbol: "",
                          }).format(),
                      },
                      {
                        title: "Delivery Location",
                        field: "D_LOC_CODE",
                      },
                    ]}
                    data={purchaseRequestJob.data}
                    isLoading={purchaseRequestJob.isLoading}
                    actions={[
                      (rowData) => ({
                        icon: "comment",
                        tooltip: "Add remark",
                        onClick: (event, rowData) => {
                          event.preventDefault();
                          history.push(
                            `/item-remark-edit-job/${rowData.PRJIDX}`
                          );
                        },
                        hidden: !isAllowed(authorizePR.data, [
                          "can_adj_view_remark",
                        ]),
                      }),
                      {
                        icon: "edit",
                        tooltip: "Edit Item",
                        onClick: (event, rowData) => {
                          history.push(
                            `/purchase-edit-job-item/${rowData.PRJIDX}/${purchaseRequest.data.PR_YEAR}/${purchaseRequest.data.PR_COUNTRYID}/${purchaseRequest.data.PR_COMPIDX}/${params.id}/${purchaseRequest.data.CREATED_SECID}/${rowData.BUDGET_CODE}`
                          );
                        },
                        disabled:
                          purchaseRequest.data &&
                          Boolean(
                            purchaseRequest.data.PR_STATUS === 60 ||
                              purchaseRequest.data.PR_STATUS === 80
                          ),
                        hidden: !isAllowed(authorizePR.data, [
                          "can_adj_edit_item",
                        ]),
                      },
                    ]}
                  />
                </TabPanel>
                <TabPanel value={valueTab} index={1}>
                  <MaterialTable
                    title
                    columns={[
                      {
                        title: "No",
                        render: (rowData) => rowData.tableData.id + 1,
                      },
                      {
                        title: "Budget Code",
                        field: "BUDGET_CODE",
                      },
                      {
                        title: "Project Code",
                        field: "BUDGETP_CODE",
                      },
                      {
                        title: "Item Name",
                        field: "ITEMS_DETAIL",
                      },
                      {
                        title: "Brand",
                        field: "PR_BRANDID",
                        lookup: renderLookupBrand(),
                      },
                      {
                        title: "Department",
                        field: "PR_DEPARTID",
                        lookup: renderLookupDepartment(),
                      },
                      {
                        title: "Price",
                        field: "PRICE",
                        render: (rowData) =>
                          currencyJS(rowData.PRICE, {
                            precision: 4,
                            symbol: "",
                          }).format(),
                      },
                      {
                        title: "Currency",
                        field: "CURR_ID",
                        lookup: renderLookupCurrencise(),
                      },
                      {
                        title: "QTY",
                        field: "QTY",
                      },
                      {
                        title: "Unit",
                        field: "PR_UNIT",
                      },
                      {
                        title: "Supplier",
                        field: "SUPNAME",
                        width: "40ch",
                      },
                      {
                        title: "Original Amount",
                        field: "PRICE",
                        render: (rowData) => {
                          let result = _.find(currencies.data, {
                            CURRENCY_ID: currencyid,
                          });
                          let originalCurrency = 0;
                          if (result) {
                            originalCurrency = result.CURRENCY_EXC_ID;
                          }
                          return currencyJS(
                            originalCurrency * rowData.PRICE * rowData.QTY,
                            {
                              precision: 4,
                              symbol: "",
                            }
                          ).format();
                        },
                      },
                      {
                        title: "Budget Amount",
                        field: "AMOUNT",
                        render: (rowData) =>
                          currencyJS(rowData.AMOUNT, {
                            precision: 4,
                            symbol: "",
                          }).format(),
                      },
                      {
                        title: "Delivery Location",
                        field: "D_LOC_CODE",
                      },
                      {
                        title: "Delivery Location",
                        field: "D_LOC",
                        hidden: true,
                      },
                      {
                        title: "Delivery Location",
                        field: "D_LOC_NAME",
                        hidden: true,
                      },
                    ]}
                    data={purchaseRequestDetails.data}
                    isLoading={purchaseRequestDetails.isLoading}
                  />
                </TabPanel>
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                flexWrap={true}
              >
                <Box display="flex">
                  <Box component="span" m={1}>
                    <Alert icon={false} variant="outlined" severity="warning">
                      <Typography variant="h5" component="h2">
                        Total Expense (Master) :{" "}
                        {currencyJS(
                          purchaseRequesteExpense.data &&
                            purchaseRequesteExpense.data.AMOUNT,
                          {
                            precision: 4,
                            symbol: "",
                          }
                        ).format()}
                      </Typography>
                    </Alert>
                  </Box>
                  <Box component="span" m={1}>
                    <Alert icon={false} variant="outlined" severity="warning">
                      <Typography variant="h5" component="h2">
                        Total Budget Amount (Master) :{" "}
                        {currencyJS(
                          sumTotal(["AMOUNT"], purchaseRequestDetails.data) +
                            (purchaseRequesteExpense.data &&
                              purchaseRequesteExpense.data.AMOUNT),
                          {
                            precision: 4,
                            symbol: "",
                          }
                        ).format()}
                      </Typography>
                    </Alert>
                  </Box>
                </Box>
                <Box display="flex">
                  <Box component="span" m={1}>
                    <Alert icon={false} variant="outlined" severity="success">
                      <Typography variant="h5" component="h2">
                        Total Expense :{" "}
                        {currencyJS(
                          purchaseRequesteExpenseJob.data &&
                            purchaseRequesteExpenseJob.data.AMOUNT,
                          {
                            precision: 4,
                            symbol: "",
                          }
                        ).format()}
                      </Typography>
                    </Alert>
                  </Box>
                  <Box component="span" m={1}>
                    <Alert icon={false} variant="outlined" severity="success">
                      <Typography variant="h5" component="h2">
                        Total Budget Amount :{" "}
                        {currencyJS(
                          sumTotal(["AMOUNT"], purchaseRequestJob.data) +
                            (purchaseRequesteExpenseJob.data &&
                              purchaseRequesteExpenseJob.data.AMOUNT),
                          {
                            precision: 4,
                            symbol: "",
                          }
                        ).format()}
                      </Typography>
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box display="flex" justifyContent="flex-end">
                <Box component="span" m={1}>
                  {Boolean(purchaseRequest.data) &&
                    hasRoleDOA(authorizePR.data, ["Purchasing Staff"]) &&
                    perid === purchaseRequest.data.ASSIGN_PURCHASE_ID &&
                    [50, 51, 53, 57].includes(
                      purchaseRequest.data.PR_STATUS
                    ) && (
                      <Button
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          Swal.fire({
                            title: "Submit your remark for reject",
                            input: "textarea",
                            inputAttributes: {
                              autocapitalize: "off",
                            },
                            showCancelButton: true,
                            confirmButtonText: "Rejected",
                            showLoaderOnConfirm: true,
                            inputValidator: (value) => {
                              return new Promise((resolve) => {
                                if (value) {
                                  resolve();
                                } else {
                                  resolve("Please fill to remark for reject !");
                                }
                              });
                            },
                            preConfirm: (remark) => {
                              return httpClient
                                .put(`/purchase-request/update/${params.id}`, {
                                  PR_H_REMARKs: {
                                    REMARK_TEXT: remark,
                                  },
                                  ASSIGN_PURCHASE_ID: perid,
                                  ASSIGN_PURCHASE_EMAIL: email,
                                  ASSIGN_PURCHASE_NAME: fullname,
                                  PR_STATUS: 80,
                                  PR_TYPE: purchaseRequest.data.PR_TYPE,
                                  REF_PR_NO: purchaseRequest.data.REF_PR_NO,
                                })
                                .then((result) => {
                                  return result.data;
                                })
                                .catch((error) => {
                                  Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                  );
                                });
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire({
                                text: `The Purchase Requesition Job (${
                                  purchaseRequest.data &&
                                  purchaseRequest.data.PR_NO
                                }) has rejected`,
                                icon: "success",
                              }).then(() => {
                                history.goBack();
                              });
                            }
                          });
                        }}
                        style={{
                          backgroundColor: red[500],
                        }}
                      >
                        <PostAddIcon />
                        Rejected
                      </Button>
                    )}
                  {Boolean(purchaseRequest.data) &&
                    hasRoleDOA(authorizePR.data, ["Purchasing Staff"]) &&
                    [50, 51, 53, 57].includes(
                      purchaseRequest.data.PR_STATUS
                    ) && (
                      <>
                        <Button
                          variant="contained"
                          disabled={Boolean(
                            purchaseRequest.data.PR_STATUS === 60 ||
                              purchaseRequest.data.PR_STATUS === 80 ||
                              purchaseRequest.data.PR_STATUS === 100
                          )}
                          onClick={() => {
                            setOpenModalAssign(true);
                          }}
                          style={{
                            backgroundColor: green[400],
                          }}
                        >
                          <ForwardIcon />
                          Forward Job
                        </Button>
                      </>
                    )}
                  {Boolean(purchaseRequest.data) &&
                    isAllowed(authorizePR.data, ["can_staff_complete"]) &&
                    perid === purchaseRequest.data.ASSIGN_PURCHASE_ID &&
                    [50, 51, 53, 57].includes(
                      purchaseRequest.data.PR_STATUS
                    ) && (
                      <Button
                        variant="contained"
                        disabled={Boolean(
                          purchaseRequest.data.PR_STATUS === 60 ||
                            purchaseRequest.data.PR_STATUS === 80 ||
                            purchaseRequest.data.PR_STATUS === 100
                        )}
                        onClick={(e) => {
                          e.preventDefault();

                          let isEmptySuplier = Object.values(
                            purchaseRequestJob.data
                          ).some((el) => el.SUPCODE === "");

                          if (!isEmptySuplier) {
                            const totalAmountJobByBudget = _(
                              purchaseRequestJob.data
                            )
                              .groupBy("BUDGET_CODE")
                              .map((objs) => ({
                                BUDGET_CODE: objs[0].BUDGET_CODE,
                                AMOUNT:
                                  parseFloat(_.sumBy(objs, "AMOUNT")) +
                                  parseFloat(_.sumBy(objs, "AVG_EXPENSE")),
                              }))
                              .value();

                            const totalAmountByBudget = _(
                              purchaseRequestDetails.data
                            )
                              .groupBy("BUDGET_CODE")
                              .map((objs) => ({
                                BUDGET_CODE: objs[0].BUDGET_CODE,
                                AMOUNT:
                                  parseFloat(_.sumBy(objs, "AMOUNT")) +
                                  parseFloat(_.sumBy(objs, "AVG_EXPENSE")),
                              }))
                              .value();

                            if (purchaseRequest.data.PR_TYPE === 2) {
                              httpClient
                                .get(
                                  `/purchase-request/avg-expense-job/${params.id}/${purchaseRequest.data.PR_YEAR}/${purchaseRequest.data.PR_COMPIDX}`
                                )
                                .then((result) => {
                                  if (result.data) {
                                    const { icon, message } = result.data;
                                    if (icon === "success") {
                                      Swal.fire({
                                        title: "Confirm to complete job ?",
                                        text: "You won't be able to revert this!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, complete it!",
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          httpClient
                                            .put(
                                              `/purchase-request/update/${params.id}`,
                                              {
                                                PR_STATUS: 60,
                                                PR_TYPE:
                                                  purchaseRequest.data.PR_TYPE,
                                                REF_PR_NO:
                                                  purchaseRequest.data
                                                    .REF_PR_NO,
                                                ASSIGN_PURCHASE_ID: perid,
                                                ASSIGN_PURCHASE_EMAIL: email,
                                                ASSIGN_PURCHASE_NAME: fullname,
                                              }
                                            )
                                            .then((result) => {
                                              Swal.fire({
                                                text: `The Purchase Requesition Job (${
                                                  purchaseRequest.data &&
                                                  purchaseRequest.data.PR_NO
                                                }) has completed`,
                                                icon: "success",
                                              }).then(() => {
                                                history.replace(
                                                  "/purchase-requisition-job"
                                                );
                                              });
                                            })
                                            .catch((error) => {
                                              Swal.fire({
                                                text: `Request failed: ${error}`,
                                                icon: "error",
                                              });
                                            });
                                        }
                                      });
                                    } else if (icon === "warning") {
                                      Swal.fire({
                                        title: "Warning",
                                        text: message,
                                        icon: "warning",
                                      });
                                    }
                                  }
                                })
                                .catch((error) => {
                                  Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                  );
                                });
                            } else {
                              compareAmount(
                                totalAmountJobByBudget,
                                totalAmountByBudget
                              ).then((result) => {
                                if (result) {
                                  Swal.fire({
                                    text: `The budget code (${result}) has over of master budget.`,
                                    icon: "warning",
                                  });
                                } else {
                                  const sumMasterAmount =
                                    sumTotal(
                                      ["AMOUNT"],
                                      purchaseRequestDetails.data
                                    ) +
                                    (purchaseRequesteExpense.data &&
                                      purchaseRequesteExpense.data.AMOUNT);
                                  const sumJobAmount =
                                    sumTotal(
                                      ["AMOUNT"],
                                      purchaseRequestJob.data
                                    ) +
                                    (purchaseRequesteExpenseJob.data &&
                                      purchaseRequesteExpenseJob.data.AMOUNT);

                                  if (
                                    Math.round(sumMasterAmount * 100000) >=
                                    Math.round(sumJobAmount * 100000)
                                  ) {
                                    httpClient
                                      .get(
                                        `/purchase-request/avg-expense-job/${params.id}/${purchaseRequest.data.PR_YEAR}/${purchaseRequest.data.PR_COMPIDX}`
                                      )
                                      .then((result) => {
                                        if (result.data) {
                                          const { icon, message } = result.data;
                                          if (icon === "success") {
                                            Swal.fire({
                                              title:
                                                "Confirm to complete job ?",
                                              text: "You won't be able to revert this!",
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#3085d6",
                                              cancelButtonColor: "#d33",
                                              confirmButtonText:
                                                "Yes, complete it!",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                httpClient
                                                  .put(
                                                    `/purchase-request/update/${params.id}`,
                                                    {
                                                      PR_STATUS: 60,
                                                      PR_TYPE:
                                                        purchaseRequest.data
                                                          .PR_TYPE,
                                                      REF_PR_NO:
                                                        purchaseRequest.data
                                                          .REF_PR_NO,
                                                      ASSIGN_PURCHASE_ID: perid,
                                                      ASSIGN_PURCHASE_EMAIL:
                                                        email,
                                                      ASSIGN_PURCHASE_NAME:
                                                        fullname,
                                                    }
                                                  )
                                                  .then((result) => {
                                                    Swal.fire({
                                                      text: `The Purchase Requesition Job (${
                                                        purchaseRequest.data &&
                                                        purchaseRequest.data
                                                          .PR_NO
                                                      }) has completed`,
                                                      icon: "success",
                                                    }).then(() => {
                                                      history.replace(
                                                        "/purchase-requisition-job"
                                                      );
                                                    });
                                                  })
                                                  .catch((error) => {
                                                    Swal.fire({
                                                      text: `Request failed: ${error}`,
                                                      icon: "error",
                                                    });
                                                  });
                                              }
                                            });
                                          } else if (icon === "warning") {
                                            Swal.fire({
                                              title: "Warning",
                                              text: message,
                                              icon: "warning",
                                            });
                                          }
                                        }
                                      })
                                      .catch((error) => {
                                        Swal.showValidationMessage(
                                          `Request failed: ${error}`
                                        );
                                      });
                                  } else {
                                    Swal.fire({
                                      text: `The purchase requisition has over of master budget.`,
                                      icon: "warning",
                                    });
                                  }
                                }
                              });
                            }
                          } else {
                            Swal.fire({
                              text: `The supplier must not be blank.`,
                              icon: "warning",
                            });
                          }
                        }}
                        style={{
                          backgroundColor: green[400],
                        }}
                      >
                        <DoneAllIcon />
                        Complete Job
                      </Button>
                    )}
                  {Boolean(purchaseRequest.data) &&
                    hasRoleDOA(authorizePR.data, ["Purchasing Staff"]) &&
                    perid === purchaseRequest.data.ASSIGN_PURCHASE_ID && (
                      <>
                        {[50, 51, 53, 57].includes(
                          purchaseRequest.data.PR_STATUS
                        ) && (
                          <Button
                            variant="contained"
                            onClick={(e) => {
                              e.preventDefault();
                              Swal.fire({
                                title: "Submit your remark for holding job",
                                input: "textarea",
                                inputAttributes: {
                                  autocapitalize: "off",
                                },
                                showCancelButton: true,
                                confirmButtonText: "Holding Job",
                                showLoaderOnConfirm: true,
                                inputValidator: (value) => {
                                  return new Promise((resolve) => {
                                    if (value) {
                                      resolve();
                                    } else {
                                      resolve(
                                        "Please fill to remark for holding job !"
                                      );
                                    }
                                  });
                                },
                                preConfirm: (remark) => {
                                  return httpClient
                                    .put(
                                      `/purchase-request/update/${params.id}`,
                                      {
                                        PR_H_REMARKs: {
                                          REMARK_TEXT: remark,
                                        },
                                        PR_STATUS: 70,
                                        PR_TYPE: purchaseRequest.data.PR_TYPE,
                                        REF_PR_NO:
                                          purchaseRequest.data.REF_PR_NO,
                                        ASSIGN_PURCHASE_ID: perid,
                                        ASSIGN_PURCHASE_EMAIL: email,
                                        ASSIGN_PURCHASE_NAME: fullname,
                                      }
                                    )
                                    .then((result) => {
                                      return result.data;
                                    })
                                    .catch((error) => {
                                      Swal.showValidationMessage(
                                        `Request failed: ${error}`
                                      );
                                    });
                                },
                                allowOutsideClick: () => !Swal.isLoading(),
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  Swal.fire({
                                    text: `The Purchase Requesition Job (${
                                      purchaseRequest.data &&
                                      purchaseRequest.data.PR_NO
                                    }) is holding`,
                                    icon: "success",
                                  }).then(() => {
                                    history.replace(
                                      `/purchase-requisition-job`
                                    );
                                  });
                                }
                              });
                            }}
                            style={{
                              backgroundColor: green[700],
                            }}
                          >
                            <PauseIcon />
                            Holding Job
                          </Button>
                        )}
                        {purchaseRequest.data.PR_STATUS === 70 && (
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: yellow[600],
                            }}
                            onClick={() => {
                              Swal.fire({
                                title: "Are you sure?",
                                text: "You want to resume?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // Resume Function Modify
                                  httpClient
                                    .put(
                                      `/purchase-request/resume/${params.id}`
                                    )
                                    .then((result) => {
                                      Swal.fire({
                                        text: result.data.message,
                                        icon: "success",
                                      }).then(() => {
                                        dispatch(
                                          getPurchaseRequestById(params.id)
                                        );
                                      });
                                    })
                                    .catch((error) => {
                                      Swal.showValidationMessage(
                                        `Request failed: ${error}`
                                      );
                                    });
                                }
                              });
                            }}
                          >
                            RESUME
                          </Button>
                        )}
                        {purchaseRequest.data &&
                          [50].includes(purchaseRequest.data.PR_STATUS) && (
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: blue[400],
                              }}
                              onClick={() => {
                                Swal.fire({
                                  title: "Confirm to do verify?",
                                  text: "You won't be able to verify this!",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    var value = {
                                      ASSIGN_PURCHASE_ID: perid,
                                      ASSIGN_PURCHASE_EMAIL: email,
                                      ASSIGN_PURCHASE_NAME: fullname,
                                    };
                                    dispatch(
                                      verifyPr(params.id, value, history)
                                    );
                                  }
                                });
                              }}
                            >
                              VERIFY PR
                            </Button>
                          )}
                      </>
                    )}
                  <Button
                    variant="contained"
                    onClick={() => {
                      history.goBack();
                    }}
                  >
                    Back
                  </Button>
                </Box>
              </Box>
            </Box>
            <AssignFormModal
              openModal={openModalAssign}
              handleCloseModal={() => {
                setOpenModalAssign(false);
              }}
              handleSubmit={(value) => {
                httpClient
                  .put(`/purchase-request/update/${params.id}`, {
                    PR_STATUS: 50,
                    ASSIGN_PURCHASE_NAME: `${value.PER_FIRSTNAME} ${value.PER_SURNAME}`,
                    ASSIGN_PURCHASE_ID: value.PER_ID,
                  })
                  .then((result) => {
                    Swal.fire({
                      text: `The Purchase Requesition Job (${
                        purchaseRequest.data && purchaseRequest.data.PR_NO
                      }) is forward to ${value.PER_FIRSTNAME} ${
                        value.PER_SURNAME
                      }`,
                      icon: "success",
                    }).then(() => {
                      history.replace("/purchase-requisition-job");
                    });
                  })
                  .catch((error) => {
                    Swal.showValidationMessage(`Request failed: ${error}`);
                  });
              }}
            />
          </CardContent>
        </Card>
      </Container>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={openAttModal}
        onClose={() => {
          setOpenAttModal(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openAttModal}>
          <div className={classes.paper}>
            {ctrlAttachfile() && (
              <FilesUploadComponent
                headerId={params.id}
                handleUpload={() => {
                  dispatch(getAllFiles(params.id));
                }}
              />
            )}
            <MaterialTable
              columns={[
                {
                  title: "File Name",
                  field: "ATT_FILENAME",
                  render: (rowData) => {
                    return (
                      <>
                        <FileCopyIcon />
                        {rowData.ATT_FILENAME}
                      </>
                    );
                  },
                },
                {
                  title: "Date Uploaded",
                  field: "CREATED_DATE",
                  type: "date",
                  render: (rowData) =>
                    Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                },
                {
                  title: "Download",
                  field: "ATTIDX",
                  render: (rowData) => (
                    <CloudDownloadIcon
                      onClick={() => {
                        Axios({
                          url: `${imageUrl}/upload/purchase-files/${rowData.ATT_FILENAME}`,
                          method: "GET",
                          responseType: "blob",
                        })
                          .then((res) => {
                            download(res.data, rowData.ATT_FILENAME);
                          })
                          .catch((err) => {
                            Swal.fire(
                              "The system has error.",
                              err.message,
                              "error"
                            );
                          });
                      }}
                    />
                  ),
                },
              ]}
              data={attachFiles.data}
              editable={{
                isDeletable: () => {
                  return ctrlAttachfile();
                },
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    setTimeout(() => {
                      dispatch(deleteFiles(oldData.ATTIDX, params.id));
                      resolve();
                    }, 1000);
                  }),
              }}
              options={{
                showTitle: false,
                search: false,
                padding: false,
              }}
            />
            <br />
            <Divider />
            <br />
            <Button
              variant="contained"
              onClick={() => {
                setOpenAttModal(false);
              }}
            >
              Close
            </Button>
          </div>
        </Fade>
      </Modal>
    </Page>
  );
}
